<template>
  <b-row>
    <b-col class="border-bottom mx-3">
      <router-link
        tag="div"
        v-for="programm in programms"
        :key="programm.id"
        class="row row-item py-2 clickable border-top"
        :to="{
          name: 'programm',
          params: { id: programm.id },
        }"
      >
        <b-col md="6">
          <ProgrammCreateUpdateInfo
            :created="programm.created"
            :updated="programm.updated"
            :physioName="(programm.physio || {}).name"
          />
          <b-row class="mt-1">
            <b-col>
              <h4 class="text-primary">{{ programm.title }}</h4>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="text-muted small">
              {{
                programm.lastFinishDate
                  ? $t('last_trained', {
                      date: $moment(programm.lastFinishDate).fromNow(),
                    })
                  : $t('never_trained')
              }}
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row class="mt-1">
            <b-col :cols="5">{{ $t('PAGE_playlist_training') }}</b-col>
            <b-col
              :cols="7"
              v-html="
                $t('PAGE_programm_times_per_week', {
                  timesPerWeek: programm.timesPerWeek,
                })
              "
            />
          </b-row>
          <b-row>
            <b-col>
              <ProgrammMeta
                :loading="loading"
                :areas="programm.areas"
                :resources="programm.resources"
                :duration="programm.duration"
                rowClass="mt-1"
              />
            </b-col>
          </b-row>
        </b-col>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LoadingLine from '@/elements/LoadingLine';
import ProgrammMeta from '@/elements/ProgrammMeta';
import ProgrammCreateUpdateInfo from '@/elements/ProgrammCreateUpdateInfo';

export default {
  name: 'ProgrammsList_list',
  props: {
    programms: {
      default: function() {
        return [];
      },
    },
    loading: { default: false },
  },
  components: { LoadingLine, ProgrammMeta, ProgrammCreateUpdateInfo },
};
</script>

<style lang="scss" scoped>
.row-item {
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgrammsList/List.vue